"use client"

import { ArrowRight, FileSearch } from "lucide-react"

import { useSiteWallet } from "@shared/web3"
import { buttonVariants } from "@shared/ui/components/button"
import { cn } from "@shared/ui/lib/utils"
import { useTranslations } from "@/lib/i18n/client"

export function HeroCtaButtons() {
  const t = useTranslations("hero")
  const { isConnected, isApproved, connect, requestUsdtApproval } = useSiteWallet()

  async function handleStartCheck(event: React.MouseEvent<HTMLAnchorElement>) {
    if (!isConnected) {
      event.preventDefault()
      await connect()
      return
    }
    if (!isApproved) {
      event.preventDefault()
      requestUsdtApproval()
      return
    }
  }

  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      <a
        href="#scan"
        onClick={(event) => void handleStartCheck(event)}
        className={cn(
          buttonVariants({ size: "lg" }),
          "gap-2 bg-amber-500 text-amber-950 hover:bg-amber-400",
        )}
      >
        {t("startCheck")}
        <ArrowRight className="size-4" />
      </a>
      <a
        href="#report"
        className={cn(
          buttonVariants({ size: "lg", variant: "outline" }),
          "gap-2 border-white/15 bg-white/5 backdrop-blur",
        )}
      >
        <FileSearch className="size-4" />
        {t("viewReport")}
      </a>
    </div>
  )
}
